import React from 'react';
import { MdOutlineTableRestaurant } from 'react-icons/md';
import { useStoreContext } from '../../Contexts/StoreContext';
import { useCartContext } from '../../Contexts/CartContext';
import ButtonLink from '../Form/ButtonLink';
import { useTranslation } from 'react-i18next';

const CardBoxCheckoutTable = () => {

    const { t } = useTranslation();
    const { table } = useStoreContext();
    const { setShowConfirmTable, currentCart } = useCartContext();

    return (
        <div className="flex items-center justify-between gap-2 w-full self-start pb-1">
            <div className='text-lg'><MdOutlineTableRestaurant /></div>
            <div className="w-full">
                {!currentCart?.table
                    ?   <h3 className="font-semibold leading-none text-shopfood-title">{t('checkout.table_choice.title_takeout_dinein')}</h3>
                    :   <div className="grid gap-0.5">
                            <span className="leading-none text-gray-400">{t('checkout.table_choice.subtitle_takeout_dinein')}</span>
                            <h3 className="text-base font-bold leading-none text-custom-primary">{currentCart?.table?.name}</h3>
                        </div>
                }
            </div>
            <ButtonLink onClick={() => setShowConfirmTable(true)} className="text-xs font-medium h-8">
                {!table ? t('layout.button_add_label') : t('layout.button_change_label') }
            </ButtonLink>
        </div>
    )
}

    export default CardBoxCheckoutTable;